import React, { useEffect } from "react";
import "./History.css";

const PUBLIC = process.env.PUBLIC_URL || "";

export default function History() {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (ioEntries) => {
                ioEntries.forEach((ioEntry) => {
                    const el = ioEntry.target;
                    if (ioEntry.isIntersecting) el.classList.add("animate");
                    else el.classList.remove("animate");
                });
            },
            { threshold: 0.2 }
        );

        const els = document.querySelectorAll(".fade-on-scroll");
        els.forEach((el) => observer.observe(el));

        return () => {
            els.forEach((el) => observer.unobserve(el));
            observer.disconnect();
        };
    }, []);

    const containerStyle = {
        "--history-bg": `url("${PUBLIC}/larawan/TGPLogoLigthning3.png")`,
        "--history-mobile-bg": `url("${PUBLIC}/larawan/TGPLogoMobile3.png")`,
    };

    return (
        <section id="about" className="history" style={containerStyle}>
            <h2 className="header1 fade-on-scroll">
                The Founding of Tau Gamma Phi Calgary: A Journey of Brotherhood
            </h2>

            <p className="section-one fade-on-scroll">
                In the face of unfamiliarity, individuals often seek connections that evoke a sense of family.
                This sentiment was exemplified by Bro. Manny Escalante (UP '73) and Bro. Alan Cruz (UST '86) as
                they sought out the Tau Gamma Phi fraternity in Calgary. Armed with nothing more than a phone
                number and a name provided by Yvette Peynado, our dedicated Triskelion Worldwide database keeper,
                Manny and Alan successfully connected for the first time.
            </p>

            <p className="section-one fade-on-scroll">
                Their shared experiences as Triskelions facilitated an immediate bond, allowing them to connect
                with fellow members during their travels across North America. Shortly after arriving in Canada
                as an immigrant, Manny met Bro. Joey Talens from PMMS in Edmonton, who graciously welcomed him
                to his first meeting.
            </p>

            <p className="section-one fade-on-scroll">
                On November 15, 2004, the Southern Alberta Regional Council was officially founded in Alan's home,
                marking a significant milestone in the establishment of Tau Gamma Phi in Calgary. The meeting
                fostered a strong camaraderie among the attendees, united by their common backgrounds and shared
                Triskelion heritage. In May 2005, Bro. Bayani Del Rosario (UP '87) extended an invitation to the
                group at his home, further solidifying their growing network.
            </p>

            <p className="section-one fade-on-scroll">
                In 2005, Bro. Donnie Arteta (TYM '92), a recent immigrant, also discovered his Triskelion family
                through the fraternity's online network. This small but dedicated group continued to seek out and
                welcome more brothers and sisters who embodied the Triskelion spirit in Calgary. Bro. Moy Lucas
                (Sta Catalina '92), who had been residing in Calgary for 15 years, expressed his excitement upon
                discovering fellow Triskelion brothers in the city.
            </p>

            <p className="section-one fade-on-scroll">
                The Tau Gamma Phi Calgary chapter gained recognition when they welcomed their first guest, Paeng (UP)
                from Vancouver, along with his family, for a brief yet vibrant celebration in the summer of 2006.
                Bro. Odie Limbaga (TYM '91), another long-time Calgarian, was pleasantly surprised to reconnect with his
                brothers in 2007. The chapter also welcomed Sis. Marinelle Arlantico (Arellano U.), the first sister to join,
                along with younger members such as Jeck, Mackie, RJ, and Jai.
            </p>

            <p className="section-one fade-on-scroll">
                The inaugural anniversary celebration of Tau Gamma Phi Calgary took place on October 4, 2007,
                marking a significant milestone in the chapter's history. By the end of that year, the fraternity
                had expanded to include more brothers and sisters, such as Dennis, Jane, Vance, Kirby, Dorien, Marlo,
                Ebeth, Ric, Ronnie, David, and Irene.
            </p>

            <p className="section-one fade-on-scroll">
                The journey of Tau Gamma Phi Calgary is a testament to the enduring bonds of brotherhood and the spirit
                of community that transcends geographical boundaries. As the chapter continues to grow, it remains committed
                to fostering connections and celebrating the rich legacy of the Triskelion family. And thus, the story of
                Tau Gamma Phi Calgary continues to unfold.
            </p>
        </section>
    );
}
